import misRutas from 'vue-routes-generator'
import DescargarCopion from './app.vue'

export default {
	install: Vue => {
		misRutas.route('/main').child('descargar-copion', {
			name: 'Descargar del copión',
			component: DescargarCopion
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/descargar-copion/vue/index.js